import React, { useCallback, useEffect, useState } from 'react';

import classNames from 'classnames';

// Component and custom settings for day names, month names and more
import { Calendar, utils } from 'react-modern-calendar-datepicker';
import { customizeLocale } from '~/helpers/calendar';
import CloseSubPopup from '~c/popups/CloseSubPopup';
import useWindowDimensions from '~/hooks/windowDimensions';

export const DateCalendar = (props) => {

  // day: real day (for example from 1 to 31 for Jan)
  // month: real month (from 1 to 12)
  // year: real year
  const {
    dates,     // Array<{day: number, month: number, year: number}>
  } = props;

  const { width } = useWindowDimensions();
  const [isDatePickerShown, setIsDatePickerShown] = useState(false); // Открыть или закрыть календарь
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    if (props.cardIdCalendarClicked !== props.cardId) {
      setIsDatePickerShown(false);
    }
  }, [props.cardIdCalendarClicked, props.cardId]);

  useEffect(() => {
    if (width < 768 && !isSmallScreen) {
      setIsSmallScreen(true);
    } else if (width >= 768 && isSmallScreen) {
      setIsSmallScreen(false);
    }
  }, [width]);

  // $c-primary
  const cPrimary = '#e0301e';
  // $c-grey-dark2
  const cGreyDark2 = '#92959c';

  const onCloseClickCalendar = (e) => {
    setIsDatePickerShown(false);
    e.stopPropagation();
  };

  const onOpenClickCalendar = () => {
    setIsDatePickerShown(true);
    props.setCardIdCalendarClicked(props.cardId);
  };

  const setDates = useCallback(() => {
  }, []);

  return (
    <div
      className="course-reg__calendar"
      onClick={onOpenClickCalendar}
    >

      {isDatePickerShown &&
        <>
          <div
            className="course-reg__date-picker"
          >
            <div className="course-reg__close-picker-container">
              <CloseSubPopup
                closeHandler={onCloseClickCalendar}
                additionalClasses={['close-date-picker']}
              />
            </div>
            <Calendar
              value={dates}
              onChange={setDates}
              shouldHighlightWeekends
              minimumDate={dates[0]}
              maximumDate={dates[dates.length - 1]}
              locale={customizeLocale}
              colorPrimary={cPrimary}
            />
          </div>
          <div className="course-reg__date-pointer"></div>
        </>
      }

      <svg width="13px" height="15px">
        <use
          href="/static/img/icons/icons.svg#i-calendar"
          width="13px"
          height="15px"
          fill={
            isSmallScreen
              ? cPrimary
              : isDatePickerShown
                ? cPrimary
                : cGreyDark2
          }
        >
        </use>
      </svg>
      <span
        className={classNames('course-reg__calendar_allDates', { 'active': isDatePickerShown })}
      >Учебные дни</span>
    </div>
  );
};
